import { IFeatureFamily } from "../../common/models/feature-family.interface";
import { createDefaultLoadable, ILoadableArray, ILoadableWrapper } from "../../common/models/loadable";

export interface IFeatureFamilyState {
    families: ILoadableArray<ILoadableWrapper<IFeatureFamily>>;
}

export const initialFeatureFamilyState: IFeatureFamilyState = {
    families: {
        ...createDefaultLoadable(),
        items: []
    }
};
